"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _jsxRuntime = require("@emotion/react/jsx-runtime");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _ckeditor5React = require("@ckeditor/ckeditor5-react");

var _classiceditor = _interopRequireDefault(require("@ckeditor/ckeditor5-editor-classic/src/classiceditor"));

var _essentials = _interopRequireDefault(require("@ckeditor/ckeditor5-essentials/src/essentials"));

var _paragraph = _interopRequireDefault(require("@ckeditor/ckeditor5-paragraph/src/paragraph"));

var _list = _interopRequireDefault(require("@ckeditor/ckeditor5-list/src/list"));

var _bold = _interopRequireDefault(require("@ckeditor/ckeditor5-basic-styles/src/bold"));

var _italic = _interopRequireDefault(require("@ckeditor/ckeditor5-basic-styles/src/italic"));

var _underline = _interopRequireDefault(require("@ckeditor/ckeditor5-basic-styles/src/underline"));

var _font = _interopRequireDefault(require("@ckeditor/ckeditor5-font/src/font"));

var _alignment = _interopRequireDefault(require("@ckeditor/ckeditor5-alignment/src/alignment"));

var _image = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/image"));

var _imageupload = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imageupload"));

var _imageresize = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imageresize"));

var _imagetoolbar = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imagetoolbar"));

var _imagestyle = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imagestyle"));

var _imageinsert = _interopRequireDefault(require("@ckeditor/ckeditor5-image/src/imageinsert"));

var _sourceediting = _interopRequireDefault(require("@ckeditor/ckeditor5-source-editing/src/sourceediting"));

var _generalhtmlsupport = _interopRequireDefault(require("@ckeditor/ckeditor5-html-support/src/generalhtmlsupport"));

var _linkimage = _interopRequireDefault(require("@ckeditor/ckeditor5-link/src/linkimage"));

var _link = _interopRequireDefault(require("@ckeditor/ckeditor5-link/src/link"));

var _function = require("../../util/function");

var _Help = _interopRequireDefault(require("../Field/Help/Help"));

var _Attachments = _interopRequireDefault(require("../Attachment/Attachments"));

var _AiPanel = _interopRequireDefault(require("../Ai/AiPanel"));

var _AiErrorPanel = _interopRequireDefault(require("../Ai/AiErrorPanel"));

var _AiSpinner = _interopRequireDefault(require("../Ai/AiSpinner"));

var _AiError = _interopRequireDefault(require("../Ai/AiError"));

var _variablesPlaceholder = _interopRequireDefault(require("./plugins/variablesPlaceholder"));

var _placeholderConverters = _interopRequireDefault(require("./plugins/variablesPlaceholder/placeholderConverters"));

var _grooveImage = _interopRequireDefault(require("./plugins/grooveImage"));

var _grooveAddAttachment = _interopRequireDefault(require("./plugins/grooveAddAttachment"));

var _grooveEnterModeConverter = _interopRequireDefault(require("./plugins/grooveEnterModeConverter"));

var _grooveInsertImage = _interopRequireDefault(require("./plugins/grooveInsertImage"));

var _grooveBase64UploadAdapter = _interopRequireDefault(require("./plugins/grooveBase64UploadAdapter"));

var _Editor = require("./Editor.styles");

// To override the default styles, this file must be imported after ClassicEditor.
var Editor = function Editor(_ref) {
  var onEditorDataChange = _ref.onEditorDataChange,
      editorData = _ref.editorData,
      className = _ref.className,
      placeholder = _ref.placeholder,
      showAddAttachment = _ref.showAddAttachment,
      attachments = _ref.attachments,
      setAttachments = _ref.setAttachments,
      onUploadFile = _ref.onUploadFile,
      onAttachmentRemove = _ref.onAttachmentRemove,
      showPluginVariablesPlaceholder = _ref.showPluginVariablesPlaceholder,
      showPluginImageInsertByUrl = _ref.showPluginImageInsertByUrl,
      showPluginImageUpload = _ref.showPluginImageUpload,
      showPluginSourceEditing = _ref.showPluginSourceEditing,
      usePluginEnterModeConverter = _ref.usePluginEnterModeConverter,
      pluginVariablesPlaceholderTypes = _ref.pluginVariablesPlaceholderTypes,
      disabled = _ref.disabled,
      help = _ref.help,
      validateStatus = _ref.validateStatus,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      onReady = _ref.onReady,
      isToolbarHidden = _ref.isToolbarHidden,
      maxUploadSize = _ref.maxUploadSize,
      maxInlineImageSize = _ref.maxInlineImageSize,
      height = _ref.height,
      minHeight = _ref.minHeight,
      maxHeight = _ref.maxHeight,
      width = _ref.width,
      minWidth = _ref.minWidth,
      maxWidth = _ref.maxWidth,
      showPluginFont = _ref.showPluginFont,
      showAiGenerated = _ref.showAiGenerated,
      showAiError = _ref.showAiError,
      onAiRetry = _ref.onAiRetry,
      onAiDone = _ref.onAiDone,
      onAiCancel = _ref.onAiCancel,
      showAiSpinner = _ref.showAiSpinner,
      converterOrName = _ref.variablesPlaceholderConverter,
      id = _ref.id;
  var variablesPlaceholderConverter = ((0, _function.isFunction)(converterOrName) ? converterOrName : _placeholderConverters["default"][converterOrName]) || _placeholderConverters["default"].percentageFormat;
  var editorToolbar = (0, _react.useMemo)(function () {
    var toolbar = ['bold', 'underline', 'italic', '|', 'alignment'];

    if (showPluginFont) {
      toolbar.push.apply(toolbar, ['|', 'fontColor', 'fontBackgroundColor']);
    }

    toolbar.push.apply(toolbar, ['|', 'numberedList', 'bulletedList', '|']);

    if (showAddAttachment) {
      toolbar.push('grooveAddAttachment');
    }

    toolbar.push('link'); // if showPluginImageUpload is true,
    // grooveUploadImage gets bundled with grooveInsertImage in the toolbar

    if (showPluginImageUpload || showPluginImageInsertByUrl) {
      //
      toolbar.push('grooveInsertImage');
    }

    if (showPluginVariablesPlaceholder) {
      // add divider
      if (toolbar[toolbar.length - 1] !== '|') {
        toolbar.push('|');
      }

      toolbar.push('placeholder');
    }

    if (showPluginSourceEditing) {
      if (toolbar[toolbar.length - 1] !== '|') {
        toolbar.push('|');
      }

      toolbar.push('sourceEditing');
    }

    return toolbar;
  }, [showPluginVariablesPlaceholder, showPluginImageInsertByUrl, showPluginImageUpload, showPluginSourceEditing, showAddAttachment, showPluginFont]);
  var editorPlugins = (0, _react.useMemo)(function () {
    var plugins = [_essentials["default"], _paragraph["default"], _generalhtmlsupport["default"]];

    if (usePluginEnterModeConverter) {
      plugins.push(_grooveEnterModeConverter["default"]);
    }

    if (!isToolbarHidden) {
      plugins.push(_alignment["default"]);
    }

    if (showPluginFont) {
      plugins.push(_font["default"]);
    }

    plugins.push.apply(plugins, [_list["default"], _bold["default"], _italic["default"], _underline["default"], _link["default"], _image["default"], _imageresize["default"], _imagetoolbar["default"], _imagestyle["default"], _imageinsert["default"], _linkimage["default"]]);

    if (showPluginImageUpload || showPluginImageInsertByUrl) {
      plugins.push(_grooveInsertImage["default"]);
    }

    if (showPluginImageUpload) {
      plugins.push(_grooveBase64UploadAdapter["default"]);
      plugins.push(_imageupload["default"]);
      plugins.push(_grooveImage["default"]);
    }

    if (showAddAttachment) {
      plugins.push(_grooveAddAttachment["default"]);
    }

    if (showPluginVariablesPlaceholder) {
      // For inserting variables feature
      plugins.push(_variablesPlaceholder["default"]);
    }

    if (showPluginSourceEditing) {
      plugins.push(_sourceediting["default"]);
    }

    return plugins;
  }, [usePluginEnterModeConverter, isToolbarHidden, showPluginFont, showPluginImageUpload, showPluginImageInsertByUrl, showAddAttachment, showPluginVariablesPlaceholder, showPluginSourceEditing]); // HACK (jscheel): Because the ckeditor react component does not update plugin
  // configurations when the editor config changes, we have to create a container
  // to store the attachments open method in. This container ref is passed to the
  // AddAttachments component, which then hydrates the ref's current pointer
  // with the open function. The ref object stays consistent between renders and
  // accessed via a callback function that we pass to the plugin config. Basically,
  // we have re-invented hoisting. Blech.

  var openFileDialogRef = (0, _react.useRef)(null);
  var openFileDialog = (0, _react.useCallback)(function () {
    openFileDialogRef.current();
  }, [openFileDialogRef]); // END HACK

  var editorConfig = (0, _react.useMemo)(function () {
    var config = {
      plugins: editorPlugins,
      toolbar: !isToolbarHidden && editorToolbar,
      placeholder: placeholder,
      // https://ckeditor.com/docs/ckeditor5/latest/features/font.html#accepting-all-font-names
      // for users that have font-family inline styles
      fontFamily: {
        supportAllValues: true
      },
      // https://ckeditor.com/docs/ckeditor5/latest/features/general-html-support.html#configuration
      htmlSupport: {
        allow: [{
          name: 'img',
          attributes: {
            width: true,
            height: true
          }
        }, {
          name: /.*/,
          styles: true
        }]
      }
    };

    if (showPluginImageUpload) {
      Object.assign(config, {
        grooveImagePluginConfig: {
          EDITOR_MAX_INLINE_IMAGE_SIZE: maxInlineImageSize,
          EDITOR_MAX_UPLOAD_SIZE: maxUploadSize,
          onInlineImageTooLarge: onUploadFile,
          onFileTooLarge: setAttachments
        },
        image: {
          // The default is percentage, which is better for responsive;
          // but we need to use px, because our app's reply editor will set the value to the image's width attribute,
          // which is only support px (https://developer.mozilla.org/en-US/docs/Web/HTML/Element/img)
          resizeUnit: 'px'
        }
      });
    }

    if (showAddAttachment) {
      Object.assign(config, {
        grooveAddAttachmentPluginConfig: {
          openFileDialog: openFileDialog
        }
      });
    }

    if (showPluginVariablesPlaceholder) {
      // Config insert variables list
      Object.assign(config, {
        variablesPlaceholderPluginConfig: {
          types: pluginVariablesPlaceholderTypes
        }
      });
    }

    return config;
  }, [editorPlugins, isToolbarHidden, editorToolbar, placeholder, showPluginVariablesPlaceholder, pluginVariablesPlaceholderTypes, showPluginImageUpload, showAddAttachment, setAttachments, onUploadFile, maxUploadSize, maxInlineImageSize, openFileDialog]);
  var sizeStyles = (0, _react.useMemo)(function () {
    return _Editor.styles.size({
      minHeight: minHeight,
      height: height,
      maxHeight: maxHeight,
      minWidth: minWidth,
      width: width,
      maxWidth: maxWidth
    });
  }, [minHeight, height, maxHeight, minWidth, width, maxWidth]);
  var updateDataWithVariablesPlaceholderConverter = (0, _react.useCallback)(function (editor) {
    if (!editor) return editor;

    var getData = function getData(options) {
      return variablesPlaceholderConverter.output(editor.getData(options));
    }; // Can't just spread the editor, it can't pass non-enumerable properties like execute function


    var newEditor = Object.create(editor);
    return Object.assign(newEditor, {
      getData: getData
    });
  }, [variablesPlaceholderConverter]);
  var handleonEditorDataChange = (0, _react.useRef)(function (event, editor) {
    if (onEditorDataChange) {
      onEditorDataChange(event, updateDataWithVariablesPlaceholderConverter(editor));
    }
  });
  var handleEditorReady = (0, _react.useRef)(function (editor) {
    if (onReady) {
      // Make sure the data is converted as in the handleonEditorDataChange
      onReady(updateDataWithVariablesPlaceholderConverter(editor));
    }
  });
  var convertedEditorData = (0, _react.useMemo)(function () {
    return variablesPlaceholderConverter.input(editorData);
  }, [editorData, variablesPlaceholderConverter]);
  var showEditor = (0, _react.useMemo)(function () {
    return !showAiSpinner && !showAiError;
  }, [showAiSpinner, showAiError]);
  var isAiSuccess = (0, _react.useMemo)(function () {
    return !showAiSpinner && showAiGenerated && !showAiError;
  }, [showAiError, showAiGenerated, showAiSpinner]);
  var isAiError = (0, _react.useMemo)(function () {
    return !showAiSpinner && showAiError;
  }, [showAiError, showAiSpinner]);
  return (0, _jsxRuntime.jsxs)("div", {
    children: [(0, _jsxRuntime.jsxs)("div", {
      css: [_Editor.styles.base, isToolbarHidden && _Editor.styles.toolbarHidden, sizeStyles, process.env.NODE_ENV === "production" ? "" : ";label:Editor;"],
      className: className,
      children: [showEditor && (0, _jsxRuntime.jsx)(_ckeditor5React.CKEditor, {
        id: id,
        editor: _classiceditor["default"],
        config: editorConfig,
        data: convertedEditorData,
        onChange: handleonEditorDataChange.current,
        disabled: disabled,
        onBlur: onBlur,
        onFocus: onFocus,
        onReady: handleEditorReady.current
      }), showAiSpinner && (0, _jsxRuntime.jsx)(_AiSpinner["default"], {}), isAiError && (0, _jsxRuntime.jsx)(_AiError["default"], {}), showAddAttachment && (0, _jsxRuntime.jsx)(_Attachments["default"].AddAttachments, {
        attachments: attachments,
        onAttachmentsChange: setAttachments,
        onUploadFile: onUploadFile,
        disabled: disabled,
        maxSize: maxUploadSize,
        openFileDialogRef: openFileDialogRef
      }), attachments && !!attachments.length && (0, _jsxRuntime.jsx)(_Attachments["default"], {
        attachments: attachments,
        onAttachmentsChange: setAttachments,
        className: "grui px-10 mb-5",
        onUploadFile: onUploadFile,
        onRemove: onAttachmentRemove,
        disabled: disabled
      }), isAiSuccess && (0, _jsxRuntime.jsx)(_AiPanel["default"], {
        onRetry: onAiRetry,
        onDone: onAiDone,
        onCancel: onAiCancel
      }), isAiError && (0, _jsxRuntime.jsx)(_AiErrorPanel["default"], {
        onRetry: onAiRetry,
        onDone: onAiDone,
        onCancel: onAiCancel
      })]
    }), help && (0, _jsxRuntime.jsx)(_Help["default"], {
      help: help,
      validateStatus: validateStatus
    })]
  });
};

Editor.propTypes = {
  /**
   * Callback for handling editor data change
   * Function(event, editor)
   */
  onEditorDataChange: _propTypes.func,

  /**
   * Editor data
   */
  editorData: _propTypes.string,
  className: _propTypes.string,

  /**
   * Placeholder for editable area
   */
  placeholder: _propTypes.string,
  onUploadFile: _propTypes.func,
  onAttachmentRemove: _propTypes.func,
  showAddAttachment: _propTypes.bool,
  showAiGenerated: _propTypes.bool,
  showAiError: _propTypes.bool,
  showAiSpinner: _propTypes.bool,
  attachments: (0, _propTypes.arrayOf)((0, _propTypes.shape)({})),
  setAttachments: _propTypes.func,
  showPluginVariablesPlaceholder: _propTypes.bool,
  // drop down that allows us insert an image via a dropdown dialog
  showPluginImageInsertByUrl: _propTypes.bool,
  showPluginImageUpload: _propTypes.bool,
  showPluginSourceEditing: _propTypes.bool,

  /**
   * Override default behaviour of how CKEditor creates container elements on Enter press
   */
  usePluginEnterModeConverter: _propTypes.bool,
  pluginVariablesPlaceholderTypes: (0, _propTypes.arrayOf)((0, _propTypes.shape)({
    key: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
    title: _propTypes.string
  })),
  disabled: _propTypes.bool,
  help: _propTypes.string,
  validateStatus: (0, _propTypes.oneOf)(['success', 'error']),
  onBlur: _propTypes.func,
  onFocus: _propTypes.func,
  // Function(editor)
  onReady: _propTypes.func,
  // No toolbar and formatting, only use it as a contenteditable div
  // when need to use the variablesPlaceholder plugin too
  isToolbarHidden: _propTypes.bool,
  maxUploadSize: _propTypes.number,
  maxInlineImageSize: _propTypes.number,
  minHeight: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  height: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  maxHeight: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  minWidth: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  width: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),
  maxWidth: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.number]),

  /**
   * Show font color and font background plugins in the toolbar
   */
  showPluginFont: _propTypes.bool,

  /**
   * Convert variables between the desired format and the ckeditor format
   */
  variablesPlaceholderConverter: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.func]),
  id: _propTypes.string,
  onAiRetry: _propTypes.func,
  onAiDone: _propTypes.func,
  onAiCancel: _propTypes.func
};
Editor.defaultProps = {
  onEditorDataChange: function onEditorDataChange() {},
  editorData: '',
  className: undefined,
  placeholder: 'Type your reply here…',
  showAddAttachment: false,
  attachments: [],
  setAttachments: function setAttachments() {},
  onUploadFile: function onUploadFile() {},
  onAttachmentRemove: function onAttachmentRemove() {},
  showPluginVariablesPlaceholder: false,
  showPluginImageInsertByUrl: false,
  showPluginImageUpload: false,
  showPluginSourceEditing: false,
  usePluginEnterModeConverter: true,
  pluginVariablesPlaceholderTypes: [],
  disabled: false,
  help: undefined,
  validateStatus: undefined,
  onBlur: function onBlur() {},
  onFocus: function onFocus() {},
  onReady: function onReady() {},
  isToolbarHidden: false,
  maxUploadSize: 900 * 1024,
  maxInlineImageSize: 100 * 1024,
  minHeight: '60px',
  height: undefined,
  maxHeight: undefined,
  minWidth: undefined,
  width: undefined,
  maxWidth: undefined,
  showPluginFont: false,
  variablesPlaceholderConverter: 'percentageFormat',
  id: undefined,
  showAiGenerated: false,
  showAiError: false,
  showAiSpinner: false,
  onAiRetry: function onAiRetry() {},
  onAiDone: function onAiDone() {},
  onAiCancel: function onAiCancel() {}
};
var _default = Editor;
exports["default"] = _default;
//# sourceMappingURL=Editor.js.map